<template>
  <section class="content">
    <admin-header
      :title="'Consolidation Point'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
      :disableQuickSearch="true"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminConsolidationPoint',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - Consolidation Points',
        searchEntityScreen: 'Admin - Consolidation Point search',
        filterEventName: 'admin-consolidation-point-filter',
        filterName: 'ConsolidationPointFilter',
        entityName: 'consolidation-point',
        transformFilterRequest: true
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/ConsolidationPoint/AdminConsolidationPoint.vue